import { useMantineTheme } from '@mantine/core';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { CustomerPortalPreview } from './CustomerPortalPreview';
import { EmailsPreview } from './EmailsPreview';
import { StorePreview } from './StorePreview';
import { BROWSER_MOCK_WIDTH } from '../../../components/OnboardingWizard/BrowserMock';
import { usePreviewScaleRatio } from '../../../components/OnboardingWizard/hooks';
import { BrandingType } from '../branding.types';

export function BrandingPreview() {
  const theme = useMantineTheme();
  const previewRatio = usePreviewScaleRatio(2460);
  const params = useParams<{ type?: BrandingType }>();

  const { content, adjustedPreviewRatio } = useMemo(() => {
    switch (params?.type) {
      case BrandingType.Store:
        return {
          content: <StorePreview />,
          adjustedPreviewRatio: previewRatio,
        };

      case BrandingType.Email:
        return {
          content: <EmailsPreview />,
          adjustedPreviewRatio: 1,
        };

      case BrandingType.CustomerPortal:
        return {
          content: <CustomerPortalPreview />,
          adjustedPreviewRatio: previewRatio,
        };

      default:
        return {
          content: null,
          adjustedPreviewRatio: 1,
        };
    }
  }, [params?.type, previewRatio]);

  return (
    <Container
      className="preview-container"
      style={{
        backgroundColor: theme.colors.gray[0],
      }}
    >
      <div style={{ transform: `scale(${adjustedPreviewRatio})` }}>
        <SlideContainer>{content}</SlideContainer>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  max-height: 100%;
`;

const SlideContainer = styled.div.attrs(() => ({
  className: 'slide-container',
}))`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-rows: 1fr;
  max-width: ${BROWSER_MOCK_WIDTH}px;

  .browser-mock-wrapper {
    height: 729px;
    width: ${BROWSER_MOCK_WIDTH}px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);

    .browser-mock-container {
      height: 100%;
      width: 100%;
      background-color: transparent;
      box-shadow: none;

      .address-bar-container {
        align-items: flex-end;
        background-color: transparent;
      }
    }
  }
`;
